import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { EngagementSurveyDetailTabsDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import PageLoading from 'modules/layout/components/Page/Loading'

export default function SurveyIndexRedirect() {
  const { surveyId } = useStrictParams<'surveyId'>()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(EngagementSurveyDetailTabsDocument, {
    variables: { surveyId: surveyId },
  })

  useEffect(() => {
    if (!loading && data?.surveys.survey) {
      const survey = data.surveys.survey
      const isPublished = ['active', 'finished', 'archived'].includes(survey.form.status)

      if (isPublished) {
        navigate(
          navigation.engagement.smart_surveys.survey.overview.fullPath({ surveyId: survey.id }),
          { replace: true }
        )
      } else {
        navigate(
          navigation.engagement.smart_surveys.survey.questions.fullPath({ surveyId: survey.id }),
          { replace: true }
        )
      }
    }
  }, [data, loading, navigate, navigation, surveyId])

  if (loading) {
    return <PageLoading />
  }

  return null
}
